import React from 'react';
import Navbar from './Navbar';
import Carrier from './Carrier';
import { RouteComponentProps } from '@reach/router';
import { Stack, MenuOverlay } from '@quotient/riq-react-ui';
import { AppContext } from '@quotient/riq-state';

const Page: React.FC<RouteComponentProps> = ({ children }) => {
  const { appState } = React.useContext(AppContext);
  const carrierRef = React.useRef<HTMLElement>(null);
  let positions: { top?: number } = {};
  const DomRect = carrierRef.current?.getBoundingClientRect();
  positions.top = DomRect?.bottom ?? 0;

  return (
    <Stack
      css={{ maxWidth: ['none', '1170px'], paddingTop: ['70px', '70px', '70px', 0], overflow: 'hidden' }}
      marginX="auto"
      direction="vertical"
    >
      <Navbar />
      <Carrier ref={carrierRef} />
      <MenuOverlay positions={positions} show={appState.isCarrierMenuOpen} />
      {children}
    </Stack>
  );
};

export default Page;
